import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { StoreService } from 'src/app/services/infra/store/store.service';
import { LoggerService } from 'src/app/services/infra/logger/logger.service';
import { IncidentCreatedSuccessfullyDialogComponent } from '../incident-created-successfully-dialog/incident-created-successfully-dialog.component';
import { timer } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-restrict-trigger-domains-dialog',
  templateUrl: './restrict-trigger-domains-dialog.component.html',
  styleUrls: ['./restrict-trigger-domains-dialog.component.scss'],
})
export class RestrictTriggerDomainsDialogComponent {
  public waitingForResponse = false;
  public domainForm: FormGroup;
  public savedDomains: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<RestrictTriggerDomainsDialogComponent>,
    private readonly _matDialog: MatDialog,
    private readonly _logger: LoggerService,
    @Inject(MAT_DIALOG_DATA) public data: RestrictTriggerDomainsDialogComponent,
    private readonly _store: StoreService,
    private readonly _fb: FormBuilder
  ) {
    this.domainForm = this._fb.group({
      domainInput: ['', [Validators.required, this.validateDomains.bind(this)]],
    });
  }

  get domainInput() {
    return this.domainForm.get('domainInput');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public validateDomains(control: any) {
    if (!control.value) return null;
    const domains = control.value.split(';').map((domain: string) => domain.trim());
    const domainRegex = /^(?!\-)(?!.*\-$)([A-Za-z0-9-]{1,63}\.)+[A-Za-z]{2,}$/;
    const allValid = domains.every((domain: string) => domainRegex.test(domain));
    return allValid ? null : { invalidDomains: true };
  }

  public saveDomains() {
    if (this.domainForm.valid) {
      const domains = this.domainInput?.value.split(';').map((domain: string) => domain.trim());
      this.savedDomains = domains;
      this.domainForm.reset();
    }
  }

  public onClose(): void {
    this.dialogRef.close();
  }

  public onCreateIncidentClick(): void {
    this.waitingForResponse = true;
    timer(1000).subscribe(() => {
      this._matDialog.open(IncidentCreatedSuccessfullyDialogComponent, {
        data: {
          dynamicSentence:
            'Trigger domains successfully updated. The agent will now only respond to triggers from the specified domains.',
        },
        disableClose: false,
        panelClass: 'sized-popup-dialog-container',
        width: `600px`,
        height: `150px`,
      });
      this.dialogRef.close();
    });
  }
}
